<template>
  <div class="scrollable-step-content">
    <v-container fluid class="pl-0 pr-10 py-0">
      <!-- Group Name -->
      <v-row class="mb-2">
        <v-col cols="8" class="py-2">
          <v-text-field
            v-model="localForm.name"
            label="Group Name *"
            outlined
            dense
            counter="100"
            :rules="[v => !!v || 'This field is required']"
            @input="emitChange"
            placeholder="Enter group name"
            required
          />
        </v-col>
      </v-row>
      
      <!-- Description Section -->
      <v-row class="mb-2">
        <v-col cols="8" class="py-2">
          <v-textarea
            v-model="localForm.description"
            label="Description"
            outlined
            dense
            rows="3"
            counter="200"
            maxlength="200"
            :rules="[v => !v || v.length <= 200 || 'Description cannot exceed 200 characters']"
            @input="emitChange"
            placeholder="Enter group description (optional)"
          />
        </v-col>
      </v-row>

      <!-- Active Checkbox -->
      <v-row class="mb-2">
        <v-col cols="8" class="py-2">
          <v-card outlined class="pa-3">
            <v-checkbox
              v-model="localForm.active"
              label="Active"
              @change="emitChange"
              class="mt-0 pt-0 mb-0"
              dense
            />
          </v-card>
        </v-col>
      </v-row>

      <!-- Smart Group Checkbox -->
      <v-row>
        <v-col cols="8" class="py-2">
          <v-card outlined class="pa-3">
            <v-checkbox
              v-model="localForm.isSmartGroup"
              label="Automatic Operator group"
              @change="handleSmartGroupChange"
              class="mt-0 pt-0 mb-1"
              dense
            />
            <p class="text-caption grey--text mt-1 mb-0" style="line-height: 1.3;">
              Groups marked as "Automatic Operator group" are assigned to newly created operators by default.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "GroupMainInfo",
  props: {
    form: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localForm: { ...this.form },
    };
  },
  methods: {
    emitChange() {
      this.$emit("update:form", this.localForm);
    },
    handleSmartGroupChange() {
      // When smart group is enabled, set type to 'smart'
      if (this.localForm.isSmartGroup) {
        this.localForm.type = 'manual';
        this.localForm.automatic_operator_group = true;
      } else {
        this.localForm.type = 'manual';
        this.localForm.automatic_operator_group = false;
      }
      this.emitChange();
    },
    validate() {
      const errors = {};
      
      // Name validation
      if (!this.localForm.name || this.localForm.name.trim().length === 0) {
        errors.name = ["Group name is required"];
      } else if (this.localForm.name.length < 3) {
        errors.name = ["Group name must be at least 3 characters"];
      } else if (this.localForm.name.length > 100) {
        errors.name = ["Group name must be less than 100 characters"];
      }
      
      // Description validation
      if (this.localForm.description && this.localForm.description.length > 200) {
        errors.description = ["Description cannot exceed 200 characters"];
      }
      
      return Object.keys(errors).length === 0;
    },
  },
  watch: {
    form: {
      handler(newVal) {
        this.localForm = { ...newVal };
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.scrollable-step-content {
  width: 100%;
  max-height: 60vh;
  overflow-y: auto;
  padding: 12px 0;
}

/* Compact container */
.v-container {
  padding: 0 !important;
}

/* Compact columns */
.v-col {
  padding: 4px 12px !important;
}

/* Compact rows */
.v-row {
  margin: 0 0 6px 0 !important;
}

.v-row:last-child {
  margin-bottom: 0 !important;
}

/* Checkbox cards styling */
.v-card {
  transition: border-color 0.2s ease;
  border-radius: 6px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
}

.v-card:hover {
  border-color: var(--v-primary-base) !important;
}

/* Compact checkbox styling */
.v-input--checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.v-input--checkbox .v-input__slot {
  margin-bottom: 0 !important;
}

.v-input--checkbox .v-messages {
  display: none;
}

/* Compact text fields */
.v-text-field--outlined .v-input__control {
  min-height: 48px !important;
}

.v-textarea--outlined .v-input__control {
  min-height: auto !important;
}

/* Description text styling */
.text-caption {
  font-size: 0.75rem !important;
  line-height: 1.3 !important;
}
</style>
